module.exports = __webpack_public_path__ + "static/tomato-10aad31e8dc41b0f9845837eb01cd0cf.png";